// Utils
import { isObjectId } from '../../../objectIdentity';
/**
 * Unmap the given value value, such that encoded object ids are converted to their associated
 * objects(defined in the objectMap)
 *
 * @param {any} value
 * @param {ObjectMap} objectMap
 *
 * @return {any}
 */
export var resolveObjectIdsToValues = function (value, objectMap) {
    if (Array.isArray(value)) {
        return value.map(function (item) { return resolveObjectIdsToValues(item, objectMap); });
    }
    if (typeof value === 'string' && isObjectId(value)) {
        return objectMap[value];
    }
    return value;
};
//# sourceMappingURL=resolveObjectIdsToValues.js.map